import {localShortDatePlusTimeFormatter} from "../../gridFormatters";


export const collectionStatusDefs = [
    {
        field: "deviceTypeCode",
        headerName: "Device Type",
    },
    {
        field: "collectionDeviceId",
        headerName: "Collection Device ID",
    },
    {
        field: "timeStamp",
        headerName: "Last Update",
        cellRenderer: localShortDatePlusTimeFormatter,
    },
    {
        field: "status",
        headerName: "Status",
    },
        {
        field: "message",
        headerName: "Message",
    },
    {
        field: "jobId",
        headerName: "Job Id",
        hide: true,
    },
];
